if (typeof CartCompatibility !== "function") {
	class CartCompatibility extends HTMLElement {
		constructor() {
			super();

			this.init()
		}

    init() {
      const cartItems = document.querySelectorAll('[data-js-cart-item]')
      const incompatableNoteWrapper = document.querySelector('[data-checkout-compatability]')
      const incompatableNote = document.querySelector('[data-checkout-compatability] [data-cart-note]')

      const items = {}
      const pickup_array = [];

      for (let i = 0; i < cartItems.length; i++) {
        const item = cartItems[i];

        const variantId = item.dataset.productId;
        items[variantId] = {
          product: item.dataset.title,
          shippable: false,
          pickup: []
        };

        item.dataset.shippable && (items[variantId].shippable = true)

        if (item.dataset.shippable) {
          pickup_array.push(item.dataset.productId)
        }

        const pickup_items = item.dataset.storeAvailability.split(',');
        for (let i = 0; i < pickup_items.length; i++) {
          const element = pickup_items[i];
          items[variantId].pickup.push(element);
        }
      }

      function findCommonPickupValues(objects, propertyName) {
        const objectKeys = Object.keys(objects);
        const firstObjectKey = objectKeys[0];
        if(!firstObjectKey || !propertyName) return

        const firstArray = objects[firstObjectKey][propertyName];

        const locationValues = [];

        for (let i = 0; i < firstArray.length; i++) {
          const currentValue = firstArray[i];
          let isCommonValue = true;

          for (let j = 1; j < objectKeys.length; j++) {
            const currentObjectKey = objectKeys[j];
            const currentArray = objects[currentObjectKey][propertyName];

            if (!currentArray.includes(currentValue)) {
              isCommonValue = false;
              break;
            }
          }

          if (isCommonValue) {
            locationValues.push(currentValue);
          }
        }

        return locationValues;
      }

      const locationValues = findCommonPickupValues(items, 'pickup');
      if(!locationValues) return

      let shippingNote = ''

      if (pickup_array.length == cartItems.length) {
        shippingNote = ' <span class="font-bold">shipping</span> or'
      }

      incompatableNoteWrapper.classList.remove('hidden');
      console.log(incompatableNoteWrapper);
      if (locationValues.length > 0) {
        incompatableNote.innerHTML = `
          The items in your cart are${!shippingNote ? ' only' : ''} available for${shippingNote} <span class="font-bold">pick up</span> at the following location${locationValues.length > 1 ? 's' : ''}:
          <ul class="list-disc ml-4 mt-2">
            ${locationValues.map(location => `<li>${location}</li>`).join('')}
          </ul>
        `;

        this.toggleCheckoutButtons(false);

      } else {
        let products = [];

        Object.keys(items).forEach((key) => {
          products.push(items[key])
        });

        this.querySelector('svg path').style.fill = 'red'
        this.querySelector('.cart-compatibility-inner').style.borderColor = 'red'

        incompatableNote.innerHTML = `
          Unable to checkout. The items in your cart are not compatible with each other.
          <br><br>
          Make sure all items in your cart are available for pickup at the same location and/or shippable.
          <br><br>
          Pickup locations by product:
          <ul class="list-disc ml-4 mt-2">
            ${products.map(item => `<li class="mb-2">
              <b>${item.product.slice(0, 15)}...</b> - ${item.pickup.map(pickup => `${pickup}`).join(', ')}
            </li>`).join('')}
          </ul>
        `;

        this.toggleCheckoutButtons();
      }
    }

    toggleCheckoutButtons(hidden = true) {
      const AjaxCartSubtotal = this.closest('#AjaxCartSubtotal');

      console.log(AjaxCartSubtotal, AjaxCartSubtotal.querySelector('.cart__details'));

      if (hidden) {
        AjaxCartSubtotal.querySelector('.cart__details').classList.add('hidden');
      } else {
        AjaxCartSubtotal.querySelector('.cart__details').classList.remove('hidden');
      }
    }
	}

	if (typeof customElements.get("cart-compatibility") == "undefined") {
		customElements.define("cart-compatibility", CartCompatibility);
	}
}
